import { render, staticRenderFns } from "./PublishModal.vue?vue&type=template&id=c57f7a58&scoped=true&"
import script from "./PublishModal.vue?vue&type=script&lang=js&"
export * from "./PublishModal.vue?vue&type=script&lang=js&"
import style0 from "./PublishModal.vue?vue&type=style&index=0&id=c57f7a58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c57f7a58",
  null
  
)

export default component.exports